export default __webpack_public_path__ + "7c46583dc9591e20f6d6f5dc74f09079.svg";